export type AppEnvironment = 'local' | 'staging' | 'prod'

/**
 * Resolve the frontend's deployment environment.
 *
 * The explicit VITE_ENVIRONMENT remains authoritative, but production must not silently
 * fall back to staging merely because a build-time variable was omitted. The browser host
 * is a trustworthy second signal for our own deployed frontend origins.
 */
export function resolveEnvironment(): AppEnvironment {
  const configured = import.meta.env.VITE_ENVIRONMENT
  if (configured === 'prod') return 'prod'
  if (configured === 'staging') return 'staging'
  if (import.meta.env.DEV) return 'local'

  const hostname =
    typeof window === 'undefined' ? '' : window.location.hostname.trim().toLowerCase()

  // Current/canonical production domains, plus the production Amplify branch hostname.
  if (
    hostname === 'tapwork.taptalent.io' ||
    hostname === 'workboard.taptalent.io' ||
    hostname === 'main.d29bhg7bxme82b.amplifyapp.com'
  ) {
    return 'prod'
  }

  // Known staging/integration hosts remain staging even when the build variable is absent.
  if (
    hostname === 'staging-tapwork.taptalent.io' ||
    hostname === 'staging-workboard.taptalent.io' ||
    hostname === 'integration.d29bhg7bxme82b.amplifyapp.com' ||
    hostname.startsWith('staging-')
  ) {
    return 'staging'
  }

  // Unknown production-build hosts remain conservative: never guess that an arbitrary host
  // is allowed to read production data.
  return 'staging'
}
